let Map = null,
    Marker = null,
    LatLngBounds = null,
    Point = null;

export async function init() {
    ({ Map } = await google.maps.importLibrary("maps"));
    ({ Marker } = await google.maps.importLibrary("marker"));
    ({ LatLngBounds, Point } = await google.maps.importLibrary("core"));

    const maps = document.querySelectorAll(".js-map");

    // If we have a map, build it!
    if (maps.length) {
        maps.forEach((mapEl) => {
            let map = new MapCanvas(mapEl);

            map.init();
        });
    }
}

class MapCanvas {
    constructor(mapEl) {
        this.mapEl = mapEl;
        this.mapCanvas = null;

        this.mapOpts = {
            zoom: 15,
            maxZoom: 16,
            scrollwheel: false,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scaleControl: false,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.LEFT_TOP,
            },
        };

        this.mapMarkers = [];
        this.markerCounter = 0;
        this.infoWindow = null;

        this.latlngbounds = new LatLngBounds();

        this.locations = mapEl
            .closest(".js-map-container")
            .querySelectorAll(".js-map-location");
    }

    init() {
        const _this = this;

        _this.buildMap();
    }

    buildMap() {
        const _this = this;

        // Create map canvas
        _this.mapCanvas = new Map(_this.mapEl, _this.mapOptions);

        _this.generateMapMarkers();

        // Ensure map isn't zoomed in too far
        google.maps.event.addListenerOnce(
            _this.mapCanvas,
            "bounds_changed",
            function () {
                this.setZoom(Math.min(this.getZoom(), 17));
            }
        );
    }

    generateMapMarkers() {
        const _this = this;

        _this.locations.forEach((el) => {
            const locationString = el.dataset.address ?? null,
                leadersString = el.dataset.leaders ?? null,
                descriptionString = el.dataset.description ?? null,
                urlString = el.dataset.url ?? null,
                latitudeString = parseFloat(el.dataset.latitude),
                longitudeString = parseFloat(el.dataset.longitude),
                markerType = el.dataset.type ?? "default",
                markerColour = el.dataset.colour ?? "#eb544b",
                markerNumber = el.dataset.number,
                title = el.dataset.title;

            let infoWindowContent = `<div class='max-w-xs text-sm'><h3 class="text-lg font-bold">${title}</h3>`;

            if (locationString) {
                if (markerType === "small-group") {
                    infoWindowContent += `<h4 class="mt-3 font-semibold">When</h4><p>${locationString
                        .split(",")
                        .join("<br>")}</p>`;
                } else {
                    infoWindowContent += `<p class="mt-3">${locationString
                        .split(",")
                        .join("<br>")}</p>`;
                }
            }

            if (leadersString) {
                infoWindowContent += `<h4 class="mt-3 font-semibold">Leaders</h4><p>${leadersString}</p>`;
            }

            if (descriptionString) {
                infoWindowContent += `<p class="mt-3">${descriptionString}</p>`;
            }

            if (urlString) {
                infoWindowContent += `<a href="${urlString}" target="_blank" class="inline-block mt-3 py-2 px-5 rounded-full bg-brand-green text-white text-base transition-all hover:bg-black">More info</a>`;
            }

            infoWindowContent += "</div>";

            let latLng = false;

            // Do we have any address data to work with?
            if (
                latitudeString === undefined &&
                longitudeString === undefined &&
                locationString === undefined
            ) {
                // We can't do anything so just continue to the next loop iteration
                return true;
            }

            latLng = {
                lat: latitudeString,
                lng: longitudeString,
            };

            _this.buildMarker(
                latLng,
                title,
                infoWindowContent,
                markerColour,
                markerNumber
            );
        });
    }

    buildMarker(latLng, title, infoWindowContent, markerColour, markerNumber) {
        const _this = this;

        const markerIcons = {
            0:
                '<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M7.36614 1.82114C8.89226 3.34706 8.93219 5.80867 7.45634 7.38327L7.36614 7.47657L5.481 9.36129C4.98463 9.85734 4.18868 9.88357 3.66075 9.42127L3.59674 9.36129L1.71117 7.47614C-0.465473 5.29954 0.530423 1.58288 3.50371 0.786196C4.88364 0.41645 6.356 0.810961 7.36614 1.82114ZM4.53866 3.31575C3.51258 3.31572 2.87134 4.42642 3.3843 5.31501C3.6224 5.72748 4.06242 5.98156 4.53866 5.98152C5.5647 5.98149 6.20601 4.8707 5.69294 3.98215C5.45484 3.5698 5.01482 3.31575 4.53866 3.31575Z" fill="' +
                markerColour +
                '"/>' +
                "</svg>",
            1:
                '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M5 0.5C3.67392 0.5 2.40215 1.02678 1.46447 1.96447C0.526784 2.90215 0 4.17392 0 5.5C0 7.69375 3.125 13 4.46875 15.2C4.5248 15.2904 4.60302 15.3651 4.69598 15.4168C4.78895 15.4686 4.8936 15.4958 5 15.4958C5.1064 15.4958 5.21105 15.4686 5.30402 15.4168C5.39698 15.3651 5.4752 15.2904 5.53125 15.2C6.875 13 10 7.69375 10 5.5C10 4.17392 9.47322 2.90215 8.53553 1.96447C7.59785 1.02678 6.32608 0.5 5 0.5ZM5 7.6875C4.56735 7.6875 4.14442 7.55921 3.78469 7.31884C3.42496 7.07847 3.14458 6.73683 2.97901 6.33712C2.81345 5.93741 2.77013 5.49757 2.85453 5.07324C2.93894 4.64891 3.14728 4.25913 3.4532 3.9532C3.75913 3.64728 4.14891 3.43894 4.57324 3.35453C4.99757 3.27013 5.43741 3.31345 5.83712 3.47901C6.23683 3.64458 6.57847 3.92496 6.81884 4.28469C7.05921 4.64442 7.1875 5.06735 7.1875 5.5C7.1875 5.78727 7.13092 6.07172 7.02099 6.33712C6.91105 6.60252 6.74992 6.84367 6.5468 7.0468C6.34367 7.24992 6.10252 7.41105 5.83712 7.52099C5.57172 7.63092 5.28727 7.6875 5 7.6875Z" fill="' +
                markerColour +
                '"/>' +
                "</svg>",
        };

        const mapMarker = new Marker({
            position: latLng,
            map: _this.mapCanvas,
            title: title,
            icon: {
                // path: "M.294 9.522c-.392.411-.392.987 0 1.398l4.55 4.772c.391.41.94.41 1.332 0l11.53-12.093c.392-.411.392-.987 0-1.398L15.902.308c-.392-.41-.941-.41-1.333 0L5.47 9.851 3.43 7.712c-.392-.411-.94-.411-1.333 0L.294 9.522Z",
                url:
                    "data:image/svg+xml;charset=utf-8," +
                    encodeURIComponent(markerIcons[1]),
                fillColor: markerColour,
                fillOpacity: 1,
                strokeOpacity: 0,
                scaledSize: new google.maps.Size(26, 42),
                anchor: new Point(26, 42),
            },
        });

        // Add occassionLatLng to array of marker positions
        // so we can re-use them on any resize events
        _this.mapMarkers.push(mapMarker);

        // Add event listener fon marker click to open info window
        google.maps.event.addListener(mapMarker, "click", function () {
            // Close any open info windows
            if (_this.infoWindow) {
                _this.infoWindow.close();
            }

            // Set the infoWindow to use new content, then open it
            _this.infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent,
            });

            _this.infoWindow.open(_this.mapCanvas, mapMarker);
        });

        // Extend the bounds of the map viewport to include this marker
        _this.latlngbounds.extend(latLng);

        // Update marker counter by 1
        _this.markerCounter++;

        // If we've added all the markers to our map let's set the final position and zoom level
        if (_this.markerCounter === _this.locations.length) {
            _this.setMapPositionAndZoom();
        }
    }

    setMapPositionAndZoom() {
        const _this = this;

        // Set the map centre point
        _this.mapCanvas.setCenter(_this.latlngbounds.getCenter());
        _this.mapCanvas.fitBounds(_this.latlngbounds);
    }
}
